import { render } from "./Link.vue?vue&type=template&id=56b8902d&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=56b8902d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56b8902d"

export default script